import { memo } from 'react'

import { CountryConditionFields } from '../../../../../domain/models/content-fields'
import { AVAILABLE_COUNTRIES } from '../../../../constants'
import { TextBodyBold } from '../../../base'
import { HtInfoPanel } from '../../../base/ht-info-panel/ht-info-panel'
import { COUNTRIES } from '../../constants'
import { SortableDropdownWidgetField } from '../../editor-widgets/sortable-dropdown-widget'
import { EditorProps } from '../../node-editor-panel'
import { UniqueIdentifierField } from '../../unique-identifier/unique-identifier-widget'

interface CountryEditorProps extends EditorProps {
  nodeContent: CountryConditionFields
}

export const CountryConditionEditor = memo(
  ({ nodeContent, ...props }: CountryEditorProps): JSX.Element => {
    return (
      <>
        <TextBodyBold>Country</TextBodyBold>
        <UniqueIdentifierField
          {...props}
          {...nodeContent}
          value={nodeContent.code}
        />
        <SortableDropdownWidgetField
          {...props}
          nodeContent={nodeContent}
          contentType={nodeContent.contentType()}
          applyButtonText='Add countries'
          field={COUNTRIES}
          values={nodeContent.countries}
          availableItems={AVAILABLE_COUNTRIES}
          searchPlaceholder='Search countries'
        />
        <HtInfoPanel
          title='About country condition'
          text={
            'Use this condition to set different flows for specific countries, for example, to show a different policy depending on the country where the user is located despite their language.'
          }
        ></HtInfoPanel>
      </>
    )
  }
)
